export const UPDATE_MERCHANT_APPLICATION_WORLDPAY_PO = gql`
    mutation updateMerchantApplicationWorldpayPO($input: AddMerchantApplicationWorldPayPOInput!) {
        updateMerchantApplicationWorldpayPO(input: $input)
    }
`;
